import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Home, Phone } from 'lucide-react';
import { BRAND } from '../mock';
import { Button } from '../components/ui/button';

export default function ThankYou() {
  useEffect(() => { document.title = 'Thank You | StreetFleet'; }, []);

  return (
    <section className="min-h-[70vh] bg-[#f5f7f8] flex items-center justify-center py-20 px-4">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-10 text-center">
        <div className="w-20 h-20 rounded-full bg-[#17A2C4]/10 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 size={44} className="text-[#17A2C4]" />
        </div>
        <h1 className="text-3xl font-extrabold text-[#4E4E50] mb-3">Thank you for your form submission.</h1>
        <p className="text-gray-600 mb-8">
          We&rsquo;ve received your booking request and our dispatch team will be in touch shortly.
          For anything urgent, call us at{' '}
          <a href={BRAND.phoneHref} className="text-[#17A2C4] font-bold">{BRAND.phone}</a>.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button className="w-full sm:w-auto bg-[#17A2C4] hover:bg-[#128aa8] text-white font-bold gap-2">
              <Home size={18} /> Back to home
            </Button>
          </Link>
          <a href={BRAND.phoneHref}>
            <Button variant="outline" className="w-full sm:w-auto border-[#4E4E50] text-[#4E4E50] font-bold gap-2">
              <Phone size={18} /> {BRAND.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
